/**
 * Ternary as a function call so it doesn't count as a branch for ESLint's `complexity` rule.
 * @param {*} condition
 * @param {number|string} whenTrue
 * @param {number|string} whenFalse
 * @returns {number|string}
 */
export const pickIf = (condition, whenTrue, whenFalse) =>
  condition ? whenTrue : whenFalse;
